import { useCallback, useState } from 'react'
import { getRecipientTimeline } from '../services/campaignsApi'
import type { CampaignTimelineEntry } from '../types'

// Fetched on demand (not on mount) — the recipient table can list dozens of rows,
// and nobody wants the per-recipient timeline for all of them until they actually
// expand one.
export function useRecipientTimeline(workspaceId: string, campaignId: string) {
  const [timelines, setTimelines] = useState<Record<string, CampaignTimelineEntry[]>>({})
  const [loadingIds, setLoadingIds] = useState<Record<string, boolean>>({})
  const [errors, setErrors] = useState<Record<string, string>>({})

  const load = useCallback(
    (recipientId: string) => {
      setLoadingIds((prev) => ({ ...prev, [recipientId]: true }))
      setErrors((prev) => {
        const copy = { ...prev }
        delete copy[recipientId]
        return copy
      })
      getRecipientTimeline(workspaceId, campaignId, recipientId)
        .then((entries) => setTimelines((prev) => ({ ...prev, [recipientId]: entries })))
        .catch((err) => setErrors((prev) => ({ ...prev, [recipientId]: err instanceof Error ? err.message : 'Failed to load' })))
        .finally(() => setLoadingIds((prev) => ({ ...prev, [recipientId]: false })))
    },
    [workspaceId, campaignId],
  )

  return { timelines, loadingIds, errors, load }
}
